import { Link, useLocation } from "react-router-dom";
import { ShieldX } from "lucide-react";
import { usePermissions } from "@/hooks/usePermissions";
import { getDefaultAdminRoute } from "@/routes/admin-route-registry";

export default function ForbiddenPage() {
  const location = useLocation();
  const { userRole } = usePermissions();
  const attemptedPath = (location.state as { from?: { pathname?: string } })
    ?.from?.pathname;

  return (
    <div className="mx-auto max-w-xl rounded-2xl border border-slate-200 bg-white p-10 text-center shadow-sm">
      <ShieldX className="mx-auto h-10 w-10 text-amber-500" />
      <h1 className="mt-4 text-2xl font-black text-slate-900">Access denied</h1>
      <p className="mt-2 text-sm text-slate-500">
        Your platform role does not allow access to
        {attemptedPath ? ` ${attemptedPath}` : " this control"}.
      </p>
      <Link
        to={getDefaultAdminRoute(userRole)}
        className="mt-6 inline-flex rounded-xl bg-slate-900 px-4 py-2 text-xs font-semibold uppercase tracking-wide text-white"
      >
        Return to your console
      </Link>
    </div>
  );
}
